export default function Badge() {
  return {}
}
